import React, { useEffect, useState } from 'react';
import axios from 'axios';
import api from '../api/axios';

export default function VideoGrid() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await api.get('/api/videos');
        setVideos(response.data);
      } catch (err) {
        setError('Failed to fetch videos.');
        console.error('Error fetching videos:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <p className="text-center text-gray-600">Loading videos...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
        <p className="text-center text-red-600">{error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="max-w-7xl w-full">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">Video Gallery</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {videos.length > 0 ? (
            videos.map(video => (
              <div key={video.id} className="w-full">
                <h3 className="text-xl font-semibold mt-2">{video.name}</h3>
                <div className="relative pt-[100%] rounded-lg shadow-lg overflow-hidden"> {/* 1:1 Aspect Ratio */}
                  <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src={video.url}
                    title={video.name}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                  ></iframe>
                </div>
                <p className="text-gray-600">{video.description}</p>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-600 col-span-full">No videos found.</p>
          )}
        </div>
      </div>
    </div>
  );
}